import { RolePermissions as RolePermissions, PermissionType, ResCode, CommonResponse, BackendRoute } from './baseDefine';
import request from '@/utils/request';

export interface ResponseRolelist {
    code: ResCode;
    msg: string;
    data: RolelistData;
}

export interface RolelistData{
    rolelist: Rolelist;
}
/**
 * 权限的相关请求
 *
 * @export
 * @interface PremissionReq
 */
export interface ReqPremission {
    permissionType: PermissionType;
    roleInfo: RolePermissions;
}


export interface Rolelist {
    frontPermissions: RolePermissions[];
    backendPermissions: RolePermissions[];
}


export interface ReqBindPermission {
    premissionType: PermissionType;
    roleKey: string;                       // 用key做唯一识别码
    uids: number[];
}



/**
 * 删除时候的用到
 *
 * @export
 * @interface ReqRole
 */
export interface ReqRole {
    premissionType: PermissionType;
    roleKey: string;                       // 用roleKey做唯一识别码
}


/**
 * 创建角色，
 *
 * @export
 * @interface ReqUpdateRole
 */
export interface ReqUpdateRole {
    premissionType: PermissionType;
    roleItem: RolePermissions;                       // 创建角色可以带权限，也可以不带
}


/**
 * 返回后端路由列表
 *
 * @export
 * @interface RespBackendRoutes
 */
export interface RespBackendRoutes extends CommonResponse {
    data: BackendRouteData;           //返回         
}

export interface BackendRouteData{
    routes: BackendRoute[];      // 创建角色可以带权限，也可以不带
}



/**
 * 获取所有角色信息
 *
 * @export
 * @returns {Promise< ResponseRolelist>}
 */
export function getRoles(): Promise<ResponseRolelist> {
    return request.post<ResponseRolelist>('/admin/permission/getRolesInfo');
}


/**
 * 添加某个角色的权限
 *
 * @export
 * @param {RolePermissions} toOp
 * @returns {Promise< ResponseRolelist>}
 */
export function addPermissions(toOp: ReqPremission): Promise<CommonResponse> {
    return request.post<CommonResponse>('/admin/permission/addPermissions', toOp);
}


/**
 * 删除某个角色的权限 可批量删除
 *
 * @export
 * @param {ReqPremission} toOp
 * @returns {Promise< CommonResponse>}
 */
export function deletePermissions(toOp: ReqPremission): Promise<CommonResponse> {
    return request.post<CommonResponse>('/admin/permission/deletePermissions', toOp);
}


/**
 * 绑定角色到某个用户上
 *
 * @export
 * @param {ReqBindPermission} toOp
 * @returns {Promise< CommonResponse>}
 */
export function bindPermissions(toOp: ReqBindPermission): Promise<CommonResponse> {
    return request.post<CommonResponse>('/admin/permission/bindRole', toOp);
}


/**
 * 创建角色，如果角色已经存在，会修改权限和其他信息。
 *
 * @export
 * @param {ReqUpdateRole} toOp
 * @returns {Promise<CommonResponse>}
 */
export function updateRole(toOp: ReqUpdateRole): Promise<CommonResponse> {
    return request.post<CommonResponse>('/admin/permission/updateRole', toOp);
}


/**
 * 删除角色，删除角色要慎重操作，会导致绑定在该角色的用户没有任何权限
 *
 * @export
 * @param {ReqRole} toOp
 * @returns {Promise<CommonResponse>}
 */
export function deleteRole(toOp: ReqRole): Promise<CommonResponse> {
    return request.post<CommonResponse>('/admin/permission/deleteRole', toOp);
}


/**
 * 获取后端路由列表，需要后端配置的路由列表
 *
 * @export
 * @returns {Promise<RespBackendRoutes>}
 */
export function getBackendRoutes(): Promise<RespBackendRoutes> {
    return request.post<RespBackendRoutes>('/admin/permission/getBackendRoutes');
}
